var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$store.state.isPremiumUser)?_c('v-layout',{staticClass:"d-flex justify-center"},[(_vm.rootPath == 'https://alpaca-connect.com')?_c('Adsense',{attrs:{"data-ad-client":"ca-pub-1075252583495026","data-ad-slot":"8002978834","ins-style":_vm.$vuetify.breakpoint.xsOnly
        ? 'display:inline-block;width:320px;height:100px'
        : _vm.$vuetify.breakpoint.smAndDown
        ? 'display:inline-block;width:460px;height:60px'
        : 'display:inline-block;width:728px;height:90px'}}):_c('v-sheet',{staticClass:"d-flex justify-center align-center",attrs:{"color":"#eee","height":_vm.$vuetify.breakpoint.xsOnly
        ? 100
        : _vm.$vuetify.breakpoint.smAndDown
        ? 60
        : 90,"width":_vm.$vuetify.breakpoint.xsOnly
        ? 320
        : _vm.$vuetify.breakpoint.smAndDown
        ? 460
        : 728}},[_vm._v("\n    add01\n  ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }